import DataVTargetBlock from './target-block';
export default DataVTargetBlock;
